export const CUSTOMER_SUMMARY =["EVENT",
"TRACK",
"POOL",
"PROVINCE"];